// extracted by mini-css-extract-plugin
export default {"message":"FadeoutMessage_message__NBmDF","slidedown":"FadeoutMessage_slidedown__j13Rw","fadeout":"FadeoutMessage_fadeout__qfwIT"};